module.exports = __webpack_public_path__ + "static/media/config-unselected.77c07f83.png";